import type { ReactNode } from 'react';

import { BottomTabs } from './BottomTabs.js';
import { HeaderBar } from './HeaderBar.js';
import { Sidebar } from './Sidebar.js';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps): JSX.Element {
  return (
    <div className="min-h-screen text-brown">
      <Sidebar />
      <div className="flex min-h-screen flex-col lg:pl-64 xl:pl-72">
        <HeaderBar />
        <main className="w-full flex-1 px-4 pb-28 pt-6 md:px-6 lg:px-10 lg:pb-16 lg:pt-8 xl:px-14 2xl:px-20">
          {children}
        </main>
      </div>
      <BottomTabs />
    </div>
  );
}
